import { Card, CardContent, Typography } from '@mui/material'
import { ReactElement, useState } from 'react'
import { useParams } from 'react-router'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { resolveImplementationDetailsRoot } from 'src/routing/routing-utils'
import { MilestoneFinalReportChart } from 'src/shared/charts/milestone-final-report/MilestoneFinalReportChart'
import { PageLayout } from 'src/shared/layout/PageLayout'
import { ScreenLayout } from 'src/shared/layout/ScreenLayout'
import { FinalProjectReportExportMenu } from 'src/shared/menu/FinalProjectReportExportMenu'
import { HelpAndInstructions } from 'src/shared/presentation/HelpAndInstructions'
import { Section } from 'src/shared/presentation/Section'
import { useDelayedNavigate } from 'src/shared/utils/hooks/navigation-hooks'
import { Utils } from 'src/shared/utils/Utils'
import styled from 'styled-components'
import { useMilestoneTitle } from 'src/screens/shared/implementation/details/milestone/MilestoneTitleContext'

const LegendStyled = styled(Typography)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.text.secondary};
`

interface Props {
  baseUrl: '/pf-kap' | '/pf-pgv'
}

export const FinalReportResultsPage = ({ baseUrl }: Props): ReactElement => {
  const { projectId } = useParams()
  const title = useMilestoneTitle()

  const navigate = useDelayedNavigate()
  const { getMessage } = useMessageSource()

  const projectType = Utils.resolveProcess(baseUrl)

  const [chartBase64Image, setChartBase64Image] = useState<string>()

  const onBackHandler = () => {
    navigate(resolveImplementationDetailsRoot(baseUrl).params({ projectId }))
  }

  return (
    <ScreenLayout
      title={title}
      actions={<FinalProjectReportExportMenu process={projectType} chartBase64Image={chartBase64Image} />}
      onBack={onBackHandler}
    >
      <PageLayout>
        <Section
          id="analysis-results"
          title={getMessage('label.milestone.final.report.results')}
          helpAndInstructions={<HelpAndInstructions labelKey="label.help.milestone.final.report.results" />}
        >
          <Card>
            <CardContent>
              <MilestoneFinalReportChart setChartBase64Image={setChartBase64Image} />

              <LegendStyled variant="body2">
                {getMessage(`label.${projectType}.milestone.final.report.results.legend`)}
              </LegendStyled>
            </CardContent>
          </Card>
        </Section>
      </PageLayout>
    </ScreenLayout>
  )
}
